import { Block, ExpandIconButton, Flex, Typography, theme } from '@aloft/toolkit-sui';
// eslint-disable-next-line aloft/no-sui-chakra
import { chakra } from '@aloft/toolkit-sui/chakra';

import {
  RECOMMENDED_COMPS_STATUS_GROUP_LABELS,
  RecommendedCompsStatusGroup,
} from '../../utils/getStatusGroup.ts';
import { StatusGroupPinIcon } from './StatusGroupPinIcon.tsx';

export const StatusGroupHeaderRow = ({
  groupId,
  count,
  collapsed,
  colSpan,
  onToggle,
}: {
  groupId: RecommendedCompsStatusGroup;
  count: number;
  collapsed: boolean;
  colSpan: number;
  onToggle: () => void;
}) => (
  <tr>
    <chakra.td
      colSpan={colSpan}
      style={{
        padding: 0,
        backgroundColor: theme.colors.surface2,
        borderTop: `1px solid ${theme.colors.strokeDefault}`,
        borderBottom: `1px solid ${theme.colors.strokeDefault}`,
      }}
    >
      <Flex
        alignItems="center"
        gap="8px"
        padding="12px 16px"
        cursor="pointer"
        __dangerDoNotUseSx={{
          userSelect: 'none',
          transition: 'background-color 0.15s ease',
          _hover: { backgroundColor: theme.colors.hoverTransparentLight },
        }}
        onClick={onToggle}
      >
        <ExpandIconButton isCollapsed={collapsed} />
        <StatusGroupPinIcon variant={groupId} />
        <Typography variant="body1">{RECOMMENDED_COMPS_STATUS_GROUP_LABELS[groupId]}</Typography>
        <Typography variant="body2" color="textSecondary">
          ({count})
        </Typography>
        <Block flex={1} />
      </Flex>
    </chakra.td>
  </tr>
);
